/* Дашборд → «Тренировки сегодня»: кто из клиентов должен потренироваться сегодня и что с тренировкой —
   выполнена (во сколько), начата (сколько блоков отмечено) или ещё нет. Сначала те, кто не потренировался.
   Имя ведёт в карточку клиента, тренировка — в конструктор на сегодня. */
import { trpc } from '@tg/app-core';
import { Link } from 'react-router-dom';
import { ini, plural, today } from '../lib/format';
import { Modal } from './Modal';

const hm = (v: Date | string) => new Date(v).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
const ORDER = { none: 0, started: 1, done: 2 } as const;

export function TodayModal({ onClose }: { onClose: () => void }) {
  const q = trpc.trainer.todayList.useQuery(undefined, { refetchOnMount: 'always' });
  const list = [...(q.data || [])].sort((a, b) => ORDER[a.status] - ORDER[b.status]);
  const done = list.filter((x) => x.status === 'done').length;
  const T = today();
  return (
    <Modal
      title="Тренировки сегодня"
      onClose={onClose}
      className="tdm"
      foot={
        <>
          <span className="sp"></span>
          <Link className="btn gh" to="/calendar" onClick={onClose}>
            Открыть календарь
          </Link>
          <button className="btn" onClick={onClose}>
            Готово
          </button>
        </>
      }
    >
      {q.isLoading ? (
        <div className="tdm-s">Загружаем…</div>
      ) : !list.length ? (
        <div className="tdm-s">На сегодня тренировок не назначено</div>
      ) : (
        <>
          <div className="tdm-s">
            Выполнено {done} из {list.length} · ещё не выполнено {list.length - done}
          </div>
          <div className="tdm-l">
            {list.map((x) => {
              const name = [x.first, x.last].filter(Boolean).join(' ') || 'Клиент';
              return (
                <div className={'tdm-r' + (x.status === 'done' ? ' ok' : '')} key={x.clientId}>
                  <div className="cellname">
                    <span className="av m">{x.photo ? <img src={x.photo} alt="" /> : ini(name)}</span>
                    <span style={{ minWidth: 0 }}>
                      <Link className="n tdm-n" to={`/clients/${x.clientId}`} onClick={onClose}>
                        {name}
                      </Link>
                      <Link className="s tdm-w" to={`/constructor?client=${x.clientId}&date=${T}`} onClick={onClose}>
                        {x.title || 'Тренировка'} · {x.blocks} {plural(x.blocks, 'блок', 'блока', 'блоков')}
                      </Link>
                    </span>
                  </div>
                  {x.status === 'done' ? (
                    <span className="chip ok">выполнена{x.finishedAt ? ' · ' + hm(x.finishedAt) : ''}</span>
                  ) : x.status === 'started' ? (
                    <span className="chip warn">
                      начата · {x.marked} из {x.blocks} {plural(x.blocks, 'блока', 'блоков', 'блоков')}
                    </span>
                  ) : (
                    <span className="chip ghost">не начата</span>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}
    </Modal>
  );
}
